export default __webpack_public_path__ + "static/media/fashion.inline.0ae68ead.svg";